<div class="panel">
  <h3>Valor Financiado</h3>
  <ng-container *ngIf="!simulacao; else textoSimulacaoTemplateRef">
    <p class="max" *ngIf="!simulacao">
      Máximo {{ cotacao || 0 | currency: 'BRL':'symbol':'1.2-2' }}
    </p>
    <span class="valor-financiado__warning"
      >Modifique o Valor e obtenha uma nova simulação</span
    >
  </ng-container>
  <ng-template #textoSimulacaoTemplateRef>
    <p class="max">
      Valor Máximo a ser Financiado
      {{ cotacao || 0 | currency: 'BRL':'symbol':'1.2-2' }}
    </p>
  </ng-template>

  <div class="valor-financiado__group">
    <span class="input-group-btn data-dwn">
      <a class="btn btn-number" data-dir="dwn">
        <em class="fa fa-minus" (click)="onClickMinus()"></em>
      </a>
    </span>
    <label class="valor-financiado__valor-simular">{{
      valorSimular || 0 | currency: 'BRL':'symbol':'1.2-2'
    }}</label>
    <span class="input-group-btn data-up">
      <a class="btn btn-number" data-dir="up">
        <em class="fa fa-plus" (click)="onClickPlus()"></em>
      </a>
    </span>
  </div>

  <div class="slider">
    <app-slider-valor-financiado
      [disabled]="disabled"
      [valorMin]="valorMinimo"
      [valorMax]="cotacao"
      [(valor)]="valorSimular"
      (valorChange)="onChangeValorSimular()"
    >
    </app-slider-valor-financiado>
    <span
      class="slider-warning"
      [ngClass]="{ 'valor-financiado__warning': simulacao }"
      >Modifique o Valor e obtenha uma nova simulação</span
    >
  </div>

  <p *ngIf="simulacao" class="border"></p>

  <a
    *ngIf="simulacao"
    (click)="openModalAlterarValor()"
    class="valor-financiado__action"
    >alterar valor</a
  >
  <span *ngIf="simulacao" class="valor-financiado__info"
    >Caso queira fazer uma nova simulação, basta modificar o valor acima
    utilizando os botões, a régua ou alterando o valor.</span
  >
</div>
